import { useCallback } from 'react';

import thematicMeetingService from '@/api/thematic-meetings/thematicMeetingService';
import {
    useAgendaGeneration,
    type AgendaGenerationRequest,
} from '@/components/MeetingAgendaBuilder/useAgendaGeneration';

/**
 * The thematic meeting's agenda generation: the same wait as the post-review meeting's, on this feature's
 * endpoint. The generated agenda is returned, never written, for the manager to add or replace.
 */
export const useThematicMeetingAgendaGeneration = (meetingId: string) => {
    const request = useCallback<AgendaGenerationRequest>(
        (input) => thematicMeetingService.generateAgenda(meetingId, input),
        [meetingId],
    );

    return useAgendaGeneration(request);
};
